import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { fetchUserFeatures } from "../actions/featureAccessActions";
import { isAtPlanLimit } from "../utils/planLimits";

/**
 * Redirect when a plan quantity limit is reached.
 *
 * @param {string} limitType  - "events" | "seats" | "calendars"
 * @param {string} redirectTo - fallback route (default: subscription page)
 */
const usePlanLimitRedirect = (
  limitType,
  redirectTo = "/admin/manage-subscription",
  condition = true
) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { limits, loaded, loading } = useSelector((state) => state.featureAccess);

  useEffect(() => {
    if (!loaded && !loading) {
      dispatch(fetchUserFeatures());
    }
  }, [loaded, loading, dispatch]);

  useEffect(() => {
    if (!condition) return;
    if (!loaded) return;

    const data = limits?.[limitType];
    if (data && isAtPlanLimit(data.limit, data.used)) {
      navigate(redirectTo, { replace: true });
    }
  }, [loaded, limits, limitType, redirectTo, navigate, condition]);
};

export default usePlanLimitRedirect;
